import http from '@/utils/http.js'

// 查询字典 院校类型(college_type) 院校学历层次(education_level) 院校特色分类(college_feature) 院校性质(college_nature)
//select_subject_type 选课科目字典 sys_user_sex 用户性别字典 province_type 高考地区字典
export function dictList(id) {
    return http.get("/app-api/system/dict/data/type/" + id)

}
//字典类型列表
export function dictAllList() {
    return http.get("/app-api/system/dict/type/list")

}
// 查询院校基本信息列表
export function listCollege(query) {
    return http.get("/app-api/app/chicago/college/list", query)
}
// 查询推荐院校
export function recommendCollegeList() {
    return http.get("/app-api/app/chicago/college/recommend")
}

// 查询院校基本信息详细
export function getCollege(collegeId) {
    return http.get("/app-api/app/chicago/college/" + collegeId)
}
// 查询专业列表
export function majorList(query) {
    return http.get("/app-api/app/chicago/major/appList", query)
}
// 志愿填报--查询专业列表
export function majorLists(query) {
    return http.get("/app-api/app/chicago/major/getMajorList", query)
}
// 查询专业列表-智能志愿填报
export function majorList_zytb(query) {
    return http.get("/app-api/app/chicago/major/getMajorist", query)
}
// 查询专业详情
export function majorDetail(id) {
    return http.get("/app-api/app/chicago/major/" + id)
}
// 获取专业门类
export function topSubjectList(query) {
    return http.get("/app-api/app/chicago/major/getTopSubjectList",query);
}
// 获取专业层次
export function majorTypeList() {
    return http.get("/app-api/app/chicago/major/getMajorTypeList")
}
// 大学排行
export function rankCollegeList(query) {
    return http.get("/app-api/app/chicago/college/rank", query)
}
// 首页校园风光
export function recommendPhotoList() {
    return http.get("/app-api/app/chicago/college/recommendPhoto")
}
// 批次列表
export function batchList(query) {
    return http.get("/app-api/app/chicago/batch/list", query)
}
// 位次列表
export function provinceRankList(query) {
    return http.get("/app-api/app/chicago/scoreRank/list", query)
}
// 分数位次查询
export function provinceRankData(query) {
    return http.get("/app-api/app/chicago/scoreRank/getRank", query)
}
// 专业历年
export function enrollInfoHistory(query) {
    return http.get("/app-api/app/chicago/enrollInfo/history", query)
}
// 院校分数线
export function enrollCollegeInfo(query) {
    return http.get("/app-api/chicago/enrollCollegeInfo/listByCollege", query)
}
// 专业分数线
export function enrollMajorInfo(query) {
    return http.get("/app-api/chicago/enrollMajorInfo/listByMajor", query)
}
// 招生计划
export function listEnrollPlan(query) {
    return http.get("/app-api/chicago/enrollMajorInfo/listEnrollPlan", query)
}
// 模拟选志愿按钮
export function collegeChoiceCreate(query) {
    return http.post("/app-api/chicago/collegeChoice/create", query)
}
// 志愿填报专业历年
export function enrollInfoMajorHistory(query) {
    return http.get("/app-api/chicago/enrollInfo/major/history", query)
}
// 志愿填报院校历年
export function enrollInfoCollegeHistory(query) {
    return http.get("/app-api/chicago/enrollInfo/college/history", query)
}
// 通过年份查询科类
export function getEnrollClass(query) {
    return http.get("/app-api/app/chicago/scoreRank/getEnrollClass", query)
}